import React, { useState } from 'react';
// import { FaLock, FaPencilAlt } from 'react-icons/fa';
import PrivateMessageQuickView from '../PrivateMessage/PrivateMessageQuickView';
import { getONLYUSERSDATA } from '../../../Utils/Common';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { setActiveMsg, setPopup } from '../../../redux/messageSlice';

const PrivateMessage = ({ v }) => {
    const navigate = useNavigate();
    const { slug } = useParams();
    const dispatch = useDispatch();
    const { user, allUsers } = useSelector(state => state.message);
    const [privateMsgQuickView, setPrivateMsgQuickView] = useState(false);

    const deleteMsg = () => {
        dispatch(setActiveMsg(v));
        dispatch(setPopup({ key: 'delete_msg', value: true }))
    }

    return (
        <>
            <div>
                {/* <p className='titleBar pb-1.5'>
                    <span className="msgLinkTitle !text-sm">Add a title</span>
                    <FaPencilAlt className='editTpen !text-xs mt-0.5' />
                </p> */}
                <div className='flex items-center p-2 border dark:border-none border-teal-200 rounded-lg dark:text-white dark:border-[#d6d6d635] bgSurfaceDarkSec'>
                    <div className='w-[9%]'>
                        {/* <FaLock className='text-gray-600 dark:text-white text-xl' /> */}
                        <div className='privateLock text-gray-600 dark:text-white text-xl' />
                    </div>
                    <div className="w-[91%]">
                        <p className='text-[12px] text-gray-600 dark:text-white'>Private message to <span >{getONLYUSERSDATA(allUsers, v.secret_user?.filter(f => f !== user?.id), 'name').join(', ')}</span>
                        </p>
                        <p className="privateMsgV text-[12px] text-gray-600 dark:text-white">
                            <span onClick={() => setPrivateMsgQuickView(true)} className='mr-1 cursor-pointer'>Quick view</span> |
                            <span className='mr-1 ml-1 cursor-pointer' onClick={() => navigate(`/connect/${slug}/reply/${v?.msg_id}`)}>View &amp; reply</span> |
                            {user?.id === v?.sender &&
                                <>
                                    <span className='mr-1 ml-1 cursor-pointer' onClick={() => { dispatch(setActiveMsg(v)); dispatch(setPopup({ key: 'userList', value: { key: 'private_participants', state: true } })) }}>Add/Edit</span> |
                                </>
                            }
                            <span className='mr-1 ml-1 cursor-pointer' onClick={deleteMsg}>Delete</span>
                        </p>
                    </div>
                </div>
            </div>
            <PrivateMessageQuickView v={v} privateMsgQuickView={privateMsgQuickView} setPrivateMsgQuickView={setPrivateMsgQuickView} />
        </>
    );
};

export default PrivateMessage;